import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { xor } from './utils/xor';
import type { TableView } from 'owa-mail-list-store';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getGroupFolderWellKnownName } from 'owa-groups-shared-folders-store';
import { getGroupIdFromTableQuery, isGroupTableQuery } from 'owa-group-utils';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export const folderRestriction =
    (restrictedFolders: string[], shouldHide?: boolean) => (): boolean => {
        const isFolderInRestrictionList = restrictedFolders.includes(
            getSelectedFolderDistinguishedId()
        );
        return xor(shouldHide, isFolderInRestrictionList);
    };

function getSelectedFolderDistinguishedId(): string {
    // If we are not in inbox focusedViewFilter restriction does not apply
    let selectedFolderDistinguishedId = '';

    // Check if we are in the right folder.
    const tableView: TableView = getSelectedTableView();
    const selectedFolderId = tableView && tableView.tableQuery.folderId;

    if (isGlobalFeatureEnabled('grp-loadFolders') && isGroupTableQuery(tableView?.tableQuery)) {
        const groupId = getGroupIdFromTableQuery(tableView?.tableQuery);
        // Only compute a group folder well-known name when we have a valid groupId
        if (groupId) {
            selectedFolderDistinguishedId = getGroupFolderWellKnownName(
                groupId,
                selectedFolderId,
                getModuleContextMailboxInfo()
            );
        }
    } else {
        selectedFolderDistinguishedId = selectedFolderId && folderIdToName(selectedFolderId);
    }

    return selectedFolderDistinguishedId;
}
